<template xmlns="http://www.w3.org/1999/html">
  <div id="customPoint"></div>
  <section class="configurator__front configurator-front">
    <!--    v-if="arSelection.state == 'device'">-->
    <h3 class="configurator-front__title"
        v-if="arSelection.state == 'device'">
      Выберите тип устройства для оценки примерной стоимости
    </h3>
    <div id="scrollElement"
         class="configurator-front__slider configurator-front-slider"
         :class="{'is-scrollable' : arSelection.state != 'device'}">

      <div class="configurator-front-slider__content slider-js swipeignore"
           v-if="arData.arDevices"
           @mouseover="isSliderHovered = true"
           @mouseout="isSliderHovered = false"
           :class="{ 'stop-anim': arSelection.state != 'device' || isSliderHovered}"
      >

        <div class="configurator-front-slider__item configurator-front-slider-item"
             v-if="arSelection.state == 'device'"
             v-for="device in arData.arDevices"
             :key="device"
             :class="{'collapsed' : arSelection.state != 'device'}"
             @click="selectDevice(device)">
          <!--          , 'is-selected' : device.ID == arSelection.device.ID-->

          <div class="configurator-front-slider-item__text">
            <div class="configurator-front-slider-item__name">
              {{device.NAME}}
            </div>
          </div>
          <div class="configurator-front-slider-item__content">
            <div class="configurator-front-slider-item__img">
              <img :src="device.PICTURE">
            </div>
          </div>

        </div>
        <div class="configurator-front-slider__item configurator-front-slider-item collapsed"
             v-if="arSelection.state != 'device'"
             v-for="device in arData.arDevices"
             :key="device"
             :class="{'is-selected' : device.ID == arSelection.device.ID}"
             @click="selectDevice(device)">

          <div class="configurator-front-slider-item__text">
            <div class="configurator-front-slider-item__name">
              {{device.NAME}}
            </div>
          </div>
          <div class="configurator-front-slider-item__content">
            <div class="configurator-front-slider-item__img">
              <img :src="device.PICTURE">
            </div>
          </div>

        </div>

      </div>

    </div>
    <div class="configurator-front__description"
         v-if="arSelection.state == 'device'">
      Программа Trade-IN разработана для всех клиентов сети магазинов Nice-Case, и предоставляет свободу при выборе компенсации за ваше устройство. Помимо прямой продажи, вы можете дополнительно получить скидку на приобретение нового девайса либо широкого спектра аксессуаров. Кроме того, мы готовы принять продукт на комиссионную продажу.
    </div>

    <div class="configurator-front__buttons"
         v-if="arSelection.state == 'device'">
      <a class="btn btn-default animate-load has-ripple" href="/trade-in/">
        Информация о Trade-In
      </a>

      <a class="btn btn-default animate-load has-ripple" href="/catalog/trade_in/">
        Каталог Trade-In
      </a>
    </div>
  </section>
  <section class="configurator__menu"
           v-if="arSelection.state != 'device'">
    <div class="configurator-menu__content"
         v-if="arSelection.state != 'device'"
         :style= "arSelection.state == 'eval' ? {border: 'none'} : {}"
         :class="{'is-eval': arSelection.state == 'eval'}"
    >

      <div class="configurator-menu__sticky-wrapper">
        <div class="configurator-menu__info configurator-menu-info"
             v-if="arSelection.state != 'eval'">
          <div class="configurator-menu-info__image">
            <img :src="this.arSelection.item.PICTURE"
                 v-if="arSelection.item.PICTURE">
            <img :src="arSelection.model.PICTURE"
                 v-else-if="arSelection.model.PICTURE">
            <img :src="arSelection.device.PICTURE"
                 v-else>
          </div>
          <div class="configurator-menu-info__description"
               v-if="description"
               v-html="description">
          </div>
        </div>
      </div>

      <div class="configurator-menu__stages"
           :class="{ 'is-eval': arSelection.state == 'eval'}">


        <div class="configurator-menu__stage configurator-menu-stage"
             v-if="arSelection.state != 'eval'">

          <div class="configurator-menu__progress configurator-menu-progress">
            <div class="configurator-menu-progress__bar"></div>
            <div class="configurator-menu-progress__text"
                 v-if="this.arSelection.device.CODE =='trade_in_ipad' || this.arSelection.device.CODE =='trade_in_mac'"
            >
              01/02
            </div>
            <div class="configurator-menu-progress__text"
                 v-else
            >
              01/03
            </div>
          </div>

          <div class="configurator-menu-stage__title">
            <h4>
              Характеристики
            </h4>
            <span
                v-text="arData.arLibrary.SUBTITLES.MAIN.DETAIL_TEXT"
            ></span>
          </div>

          <div class="configurator-menu-stage__groups configurator-menu-stage-groups">
            <div class="configurator-menu-stage-group">

              <div id="models" class="configurator-menu-stage-group__title"
                   v-if="this.arSelection.device.CODE =='trade_in_ipad'">
                Тип устройства:
              </div>
              <div id="models" class="configurator-menu-stage-group__title"
                   v-else>
                Модели:
              </div>

              <ul class="configurator-menu-stage-group__list">

                <li class="configurator-menu-stage-group-list__item"
                    v-for="(model, index) in arData.arModels"
                    :key="model">
                  <button class="configurator-menu-stage-group__item configurator-menu-stage-group-item" type="button"
                          @click="selectModel(model)"
                          :class="{ 'hidden': index >= modelsQuantity, 'is-active': model.ID == arSelection.model.ID}">
                    <div class="configurator-menu-stage-group-item__text">
                      <span>{{ model.NAME }}</span>
                      <div class="configurator-menu-stage-group-item__tick">
                        <svg viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.5688 2.53195L6.53608 10.5766C6.24859 10.8645 5.87655 11 5.4876 11C5.11556 11 4.74352 10.8645 4.45603 10.5766L0.431229 6.56274C-0.143743 5.96998 -0.143743 5.03849 0.431229 4.46266C1.0062 3.88684 1.95321 3.88684 2.52818 4.46266L5.4876 7.42648L12.4718 0.431871C13.0468 -0.143957 13.9938 -0.143957 14.5688 0.431871C15.1437 1.02463 15.1437 1.95612 14.5688 2.53195Z" fill="white"/>
                        </svg>
                      </div>
                    </div>
                  </button>
                </li>

              </ul>

              <div class="configurator-menu-stage-group__more"
                   v-if="this.arData.arModels.length > 12"
                   @click="changeModelList">
                <div
                    v-if="!allShown">
                  Ещё модели
                  &#8595;
                </div>
                <div
                    v-if="allShown">
                  Свернуть
                  &#8593;
                </div>
              </div>

            </div>

            <div class="configurator-menu-stage-group"
                 id="colours"
                 v-if="arSelection.model.UF_COLOURS">

              <div class="configurator-menu-stage-group__title">
                Цвет:
              </div>

              <ul class="configurator-menu-stage-group__list">

                <li class="configurator-menu-stage-group-list__item"
                    v-for="(hex, colour) in arSelection.model.UF_COLOURS"
                    :key="colour">
                  <button class="configurator-menu-stage-group__item configurator-menu-stage-group-item" type="button"
                          @click="selectColour(colour)"
                          :class="{ 'is-active': colour == arSelection.colour, 'bright-container': hex[1] > 'A' && hex[3] > 'A' && hex[5] > 'A'}"
                          :style= "[colour == arSelection.colour ? {background: hex, border: '1px ' + hex + ' solid' } : {background: '#ffffff'}]">

                    <div class="configurator-menu-stage-group-item__color"
                         :class="{ 'bright': hex[1] > 'A' && hex[3] > 'A' && hex[5] > 'A'}"
                         :style="{background: hex}">
                      <svg viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5688 2.53195L6.53608 10.5766C6.24859 10.8645 5.87655 11 5.4876 11C5.11556 11 4.74352 10.8645 4.45603 10.5766L0.431229 6.56274C-0.143743 5.96998 -0.143743 5.03849 0.431229 4.46266C1.0062 3.88684 1.95321 3.88684 2.52818 4.46266L5.4876 7.42648L12.4718 0.431871C13.0468 -0.143957 13.9938 -0.143957 14.5688 0.431871C15.1437 1.02463 15.1437 1.95612 14.5688 2.53195Z" fill="white"/>
                      </svg>
                    </div>
                    <div class="configurator-menu-stage-group-item__text">
                      <span>{{ colour }}</span>
                    </div>
                  </button>
                </li>

              </ul>
            </div>

            <div class="configurator-menu-stage-group"
                 id="items"
                 v-if="((arData.arItems && !arSelection.model.UF_COLOURS) || (arSelection.model.UF_COLOURS && arSelection.colour)) && !hideModelsFlag ">

              <div class="configurator-menu-stage-group__title">
                {{ arData.arItems[0].DISPLAY_TITLE }}
              </div>

              <ul class="configurator-menu-stage-group__list">

                <li class="configurator-menu-stage-group-list__item"
                    v-for="(item) in arData.arItems"
                    :key="item">
                  <button class="configurator-menu-stage-group__item configurator-menu-stage-group-item" type="button"
                          @click="selectItem(item)"
                          :class="{ 'is-active': item.ID == arSelection.item.ID}">
                    <div class="configurator-menu-stage-group-item__text">
                      <span>{{ item.DISPLAY_NAME }}</span>
                      <div class="configurator-menu-stage-group-item__tick">
                        <svg viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.5688 2.53195L6.53608 10.5766C6.24859 10.8645 5.87655 11 5.4876 11C5.11556 11 4.74352 10.8645 4.45603 10.5766L0.431229 6.56274C-0.143743 5.96998 -0.143743 5.03849 0.431229 4.46266C1.0062 3.88684 1.95321 3.88684 2.52818 4.46266L5.4876 7.42648L12.4718 0.431871C13.0468 -0.143957 13.9938 -0.143957 14.5688 0.431871C15.1437 1.02463 15.1437 1.95612 14.5688 2.53195Z" fill="white"/>
                        </svg>
                      </div>
                    </div>
                  </button>
                </li>

              </ul>

            </div>

          </div>

        </div>

        <template
            v-if="(arSelection.state != 'eval') && (arSelection.state != 'item')"
            v-for="(stage, stageNumber) in arData.arProperties.PROPERTIES"
            :key="stage">

          <div class="configurator-menu__stage configurator-menu-stage"
               v-if="stage.CODE == 'PARAMETERS' || arStages[stage.CODE].active"
               :id="stage.CODE != 'PARAMETERS' ? arStages[stage.CODE].id : 'PARAMETERS'">
            <div class="configurator-menu__progress configurator-menu-progress"
                 v-if="stage.CODE != 'PARAMETERS'"
            >
              <div class="configurator-menu-progress__bar"
                   :style="arStages[stage.CODE].styleObject"
              >
              </div>
              <div class="configurator-menu-progress__text">
                {{ arStages[stage.CODE].number }}
              </div>
            </div>


            <div class="configurator-menu-stage__title"
                 v-if="stage.CODE !== 'PARAMETERS'">
              <h4>
                {{stage.NAME}}
              </h4>
              <span
                  v-text="arData.arLibrary.SUBTITLES[stage.CODE].DETAIL_TEXT"></span>
            </div>

            <div class="configurator-menu-stage__groups configurator-menu-stage-groups">
              <div class="configurator-menu-stage-group"
                   v-for="group of stage.GROUP"
                   :key="group"
                   :id="arData.arGroups[group.CODE].id"
                   :class="{ 'configurator-menu-stage-group--error': arData.arGroups[group.CODE].hasError}">

                <div class="configurator-menu-stage-group__title"
                     v-if="arData.arGroups[group.CODE].id != 'tool'">
                  {{group.NAME}}
                </div>

                <ul class="configurator-menu-stage-group__list"
                    :class="{ 'configurator-menu-stage-group__list--full-width': stage.CODE != 'TOOLS' && group.CODE != 'SCREEN', 'configurator-menu-stage-group__list--set': stage.CODE == 'TOOLS'}">

                  <li class="configurator-menu-stage-group-list__item"
                      v-for="(button) in group.PROPERTY"
                      :key="button">

                    <button class="configurator-menu-stage-group__item configurator-menu-stage-group-item" type="button"
                            @click="selectProp(stage, group, button)"

                            :class="{ 'is-active': button.active,
                                    'configurator-menu-stage-group-item--large': stage.CODE == 'TOOLS',
                                    'configurator-menu-stage-group-item--colour' : arData.arGroups[group.CODE].id == 'colour',
                                    'configurator-menu-stage-group-item--space-gray' : button.NAME == 'Space Gray',
                                    'configurator-menu-stage-group-item--silver' : button.NAME == 'Silver',
                                    'configurator-menu-stage-group-item--black' : button.NAME == 'Black',
                                    'configurator-menu-stage-group-item--white' : button.NAME == 'White',
                          }">
                      <div class="configurator-menu-stage-group-item__image"
                           v-if="stage.CODE == 'TOOLS'">
                        <img
                            :src="arData.arLibrary.TOOLS_IMAGES[arSelection.device.CODE][button.CODE].PICTURE">
                      </div>
                      <div class="configurator-menu-stage-group-item__wrapper">
                        <div class="configurator-menu-stage-group-item__text">
                          <span>{{ button.NAME }}</span>
                          <div class="configurator-menu-stage-group-item__tick">
                            <svg viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.5688 2.53195L6.53608 10.5766C6.24859 10.8645 5.87655 11 5.4876 11C5.11556 11 4.74352 10.8645 4.45603 10.5766L0.431229 6.56274C-0.143743 5.96998 -0.143743 5.03849 0.431229 4.46266C1.0062 3.88684 1.95321 3.88684 2.52818 4.46266L5.4876 7.42648L12.4718 0.431871C13.0468 -0.143957 13.9938 -0.143957 14.5688 0.431871C15.1437 1.02463 15.1437 1.95612 14.5688 2.53195Z" fill="white"/>
                            </svg>
                          </div>
                        </div>
                        <div class="configurator-menu-stage-group-item__cost"
                             v-if="stage.CODE == 'TOOLS' && costWithoutToolsMax < 1500">
                          <b>+</b> ₽100
                        </div>
                        <div class="configurator-menu-stage-group-item__cost"
                             v-if="stage.CODE == 'TOOLS' && costWithoutToolsMax >= 1500">
                          <b>+</b> ₽{{ button.VALUE }}
                        </div>
                      </div>
                    </button>
                  </li>

                </ul>

                <div class="fancy-link"
                     v-if="group.CODE == 'VISUAL' && arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE] && arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY">

                  <template v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.NEW">
                    <div class="fancy-container"
                         v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.NEW.active">
                      <div class="fancy-description">
                        <ul>
                          <li>
                            Без каких-либо следов износа вообще, отсутствуют царапины и потертости
                          </li>
                        </ul>
                      </div>
                      <div class="fancy-images"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_NEW">
                        <a data-fancybox="CONDITION_VISUAL_NEW"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_NEW.FRONT"
                           :href="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_NEW.FRONT">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="black"/>
                            <path d="M13.1428 8L11.9524 10.2059H7.66663C6.7432 10.2059 6 10.8946 6 11.75V21.4559C6 22.3114 6.74337 23 7.66663 23H24.3334C25.2568 23 26 22.3113 26 21.4559V11.75C26 10.8944 25.2566 10.2059 24.3334 10.2059H20.0476L18.8572 8H13.1428ZM16 12.6324C18.367 12.6324 20.2857 14.4101 20.2857 16.603C20.2857 18.7959 18.3669 20.5736 16 20.5736C13.6331 20.5736 11.7142 18.7959 11.7142 16.603C11.7142 14.4101 13.633 12.6324 16 12.6324Z" fill="white"/>
                          </svg>
                          <span>Фото-пример</span>
                        </a>
                        <a data-fancybox="CONDITION_VISUAL_NEW"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_NEW.GALLERY"
                           v-for="picture in arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_NEW.GALLERY"
                           :href="picture">
                        </a>
                      </div>
                    </div>
                  </template>
                  <template v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.GOOD">
                    <div class="fancy-container"
                         v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.GOOD.active">
                      <div class="fancy-description">
                        <ul>
                          <li>
                            Минимальные потертости или несколько поверхностных царапин
                          </li>
                        </ul>
                      </div>
                      <div class="fancy-images"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_GOOD">
                        <a data-fancybox="CONDITION_VISUAL_GOOD"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_GOOD.FRONT"
                           :href="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_GOOD.FRONT">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="black"/>
                            <path d="M13.1428 8L11.9524 10.2059H7.66663C6.7432 10.2059 6 10.8946 6 11.75V21.4559C6 22.3114 6.74337 23 7.66663 23H24.3334C25.2568 23 26 22.3113 26 21.4559V11.75C26 10.8944 25.2566 10.2059 24.3334 10.2059H20.0476L18.8572 8H13.1428ZM16 12.6324C18.367 12.6324 20.2857 14.4101 20.2857 16.603C20.2857 18.7959 18.3669 20.5736 16 20.5736C13.6331 20.5736 11.7142 18.7959 11.7142 16.603C11.7142 14.4101 13.633 12.6324 16 12.6324Z" fill="white"/>
                          </svg>
                          <span>Фото-пример</span>
                        </a>
                        <a data-fancybox="CONDITION_VISUAL_GOOD"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_GOOD.GALLERY"
                           v-for="picture in arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_GOOD.GALLERY"
                           :href="picture">
                        </a>
                      </div>
                    </div>
                  </template>
                  <template v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.MEDIUM">
                    <div class="fancy-container"
                         v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.MEDIUM.active">
                      <div class="fancy-description">
                        <ul>
                          <li>
                            Царапины или микросколы на корпусе (не более 4 штук);
                          </li>
                          <li>
                            Видимые царапины на экране (не более 4 штук)
                          </li>
                        </ul>
                      </div>
                      <div class="fancy-images"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_MEDIUM">
                        <a data-fancybox="CONDITION_VISUAL_MEDIUM"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_MEDIUM.FRONT"
                           :href="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_MEDIUM.FRONT">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="black"/>
                            <path d="M13.1428 8L11.9524 10.2059H7.66663C6.7432 10.2059 6 10.8946 6 11.75V21.4559C6 22.3114 6.74337 23 7.66663 23H24.3334C25.2568 23 26 22.3113 26 21.4559V11.75C26 10.8944 25.2566 10.2059 24.3334 10.2059H20.0476L18.8572 8H13.1428ZM16 12.6324C18.367 12.6324 20.2857 14.4101 20.2857 16.603C20.2857 18.7959 18.3669 20.5736 16 20.5736C13.6331 20.5736 11.7142 18.7959 11.7142 16.603C11.7142 14.4101 13.633 12.6324 16 12.6324Z" fill="white"/>
                          </svg>
                          <span>Фото-пример</span>
                        </a>
                        <a data-fancybox="CONDITION_VISUAL_MEDIUM"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_MEDIUM.GALLERY"
                           v-for="picture in arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_MEDIUM.GALLERY"
                           :href="picture">
                        </a>
                      </div>
                    </div>
                  </template>
                  <template v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.FINE">
                    <div class="fancy-container"
                         v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.FINE.active">
                      <div class="fancy-description">
                        <ul>
                          <li>
                            Видимые царапины на корпусе (более 4 штук);
                          </li>
                          <li>
                            Видимые царапины на экране (более 4 штук)
                          </li>
                        </ul>
                      </div>
                      <div class="fancy-images"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_FINE">
                        <a data-fancybox="CONDITION_VISUAL_FINE"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_FINE.FRONT"
                           :href="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_FINE.FRONT">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="black"/>
                            <path d="M13.1428 8L11.9524 10.2059H7.66663C6.7432 10.2059 6 10.8946 6 11.75V21.4559C6 22.3114 6.74337 23 7.66663 23H24.3334C25.2568 23 26 22.3113 26 21.4559V11.75C26 10.8944 25.2566 10.2059 24.3334 10.2059H20.0476L18.8572 8H13.1428ZM16 12.6324C18.367 12.6324 20.2857 14.4101 20.2857 16.603C20.2857 18.7959 18.3669 20.5736 16 20.5736C13.6331 20.5736 11.7142 18.7959 11.7142 16.603C11.7142 14.4101 13.633 12.6324 16 12.6324Z" fill="white"/>
                          </svg>
                          <span>Фото-пример</span>
                        </a>
                        <a data-fancybox="CONDITION_VISUAL_FINE"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_FINE.GALLERY"
                           v-for="picture in arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_FINE.GALLERY"
                           :href="picture">
                        </a>
                      </div>
                    </div>
                  </template>
                  <template v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.BAD">
                    <div class="fancy-container"
                         v-if="arData.arProperties.PROPERTIES.CONDITION.GROUP.VISUAL.PROPERTY.BAD.active">
                      <div class="fancy-description">
                        <ul>
                          <li>
                            Глубокие или многочисленные царапины на корпусе или дисплее
                          </li>
                        </ul>
                      </div>
                      <div class="fancy-images"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_BAD">
                        <a data-fancybox="CONDITION_VISUAL_BAD"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_BAD.FRONT"
                           :href="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_BAD.FRONT">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="black"/>
                            <path d="M13.1428 8L11.9524 10.2059H7.66663C6.7432 10.2059 6 10.8946 6 11.75V21.4559C6 22.3114 6.74337 23 7.66663 23H24.3334C25.2568 23 26 22.3113 26 21.4559V11.75C26 10.8944 25.2566 10.2059 24.3334 10.2059H20.0476L18.8572 8H13.1428ZM16 12.6324C18.367 12.6324 20.2857 14.4101 20.2857 16.603C20.2857 18.7959 18.3669 20.5736 16 20.5736C13.6331 20.5736 11.7142 18.7959 11.7142 16.603C11.7142 14.4101 13.633 12.6324 16 12.6324Z" fill="white"/>
                          </svg>
                          <span>Фото-пример</span>
                        </a>
                        <a data-fancybox="CONDITION_VISUAL_BAD"
                           v-if="arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_BAD.GALLERY"
                           v-for="picture in arData.arLibrary.FANCY_IMAGES[arSelection.device.CODE].CONDITION_VISUAL_BAD.GALLERY"
                           :href="picture"></a>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="fancy-link" v-if="group.CODE == 'BATTERY'">
                    <div class="fancy-container">
                      <div class="fancy-images">
                        <a data-fancybox="battery_guide" href="/local/assets/images/trade-in/battery-guide-1.png">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill="black"/>
                            <path d="M13.1428 8L11.9524 10.2059H7.66663C6.7432 10.2059 6 10.8946 6 11.75V21.4559C6 22.3114 6.74337 23 7.66663 23H24.3334C25.2568 23 26 22.3113 26 21.4559V11.75C26 10.8944 25.2566 10.2059 24.3334 10.2059H20.0476L18.8572 8H13.1428ZM16 12.6324C18.367 12.6324 20.2857 14.4101 20.2857 16.603C20.2857 18.7959 18.3669 20.5736 16 20.5736C13.6331 20.5736 11.7142 18.7959 11.7142 16.603C11.7142 14.4101 13.633 12.6324 16 12.6324Z" fill="white"/>
                          </svg>
                          <span>Как проверить максимальную емкость аккумулятора?</span>
                        </a>
                        <a data-fancybox="battery_guide" href="/local/assets/images/trade-in/battery-guide-2.png">
                        </a>
                      </div>
                    </div>
                </div>

              </div>
            </div>
          </div>
        </template>
        <div id="evalStage" class="configurator-menu__stage configurator-menu-stage configurator-menu-stage--last"
             v-if="arSelection.maxgrade">
          <div class="configurator-menu-stage__title" style="border-bottom: none">
            <h4 style="margin-bottom: 15px;"
                v-if="arSelection.state == 'eval'">
              Предварительная оценка устройства
            </h4>

            <div class="eval-link pseudo-button"
                 v-if="arSelection.state == 'props'"
                 @click="scrollToInactive()">
              <span>Рассчитать</span>
              <svg viewBox="0 0 72 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M71.7071 7.29289C72.0976 7.68342 72.0976 8.31658 71.7071 8.70711L65.3431 15.0711C64.9526 15.4616 64.3195 15.4616 63.9289 15.0711C63.5384 14.6805 63.5384 14.0474 63.9289 13.6569L69.5858 8L63.9289 2.34315C63.5384 1.95262 63.5384 1.31946 63.9289 0.928932C64.3195 0.538408 64.9526 0.538408 65.3431 0.928932L71.7071 7.29289ZM0 7L71 7V9L0 9L0 7Z" fill="white"/>
              </svg>
            </div>

            <div class="eval-link pseudo-button"
                 v-if="arSelection.state == 'pre-eval'"
                 @click="setState('eval', 50)">
              <span>Рассчитать</span>
              <svg viewBox="0 0 72 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M71.7071 7.29289C72.0976 7.68342 72.0976 8.31658 71.7071 8.70711L65.3431 15.0711C64.9526 15.4616 64.3195 15.4616 63.9289 15.0711C63.5384 14.6805 63.5384 14.0474 63.9289 13.6569L69.5858 8L63.9289 2.34315C63.5384 1.95262 63.5384 1.31946 63.9289 0.928932C64.3195 0.538408 64.9526 0.538408 65.3431 0.928932L71.7071 7.29289ZM0 7L71 7V9L0 9L0 7Z" fill="white"/>
              </svg>
            </div>

          </div>

          <div class="configurator-menu-stage__eval configurator-menu-stage-eval"
               v-if="arSelection.state == 'eval'">
            <div class="configurator-menu-stage-eval__content" style="padding-left: 0">

              <div class="eval-banner-block">

                <div class="eval-parameters">
                  <div class="eval-parameters__content">
                    <div class="eval-parameters__image">
                      <img :src="this.arSelection.item.PICTURE"
                           v-if="arSelection.item.PICTURE">
                      <img :src="arSelection.model.PICTURE"
                           v-else-if="arSelection.model.PICTURE">
                      <img :src="arSelection.device.PICTURE"
                           v-else>
                    </div>
                    <div class="eval-parameters__text">
                      <div class="eval-parameters__title"
                           v-html="evalTitle">
                      </div>
                      <div class="eval-parameters__description"
                           v-html="evalDescription">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="eval-select eval-select--1">
                  <div class="eval-select__container">
                    <a href="https://nice-case.ru/catalog/trade_in/" class="eval-select__button button-select-more no-decoration">Купить другое устройство</a>
                    <div class="eval-select__text">Выберите другое устройство в каталоге нашего интернет-магазина со скидкой</div>
                    <div class="eval-select__links">
                      <div class="eval-select__link"
                           @click="scrollToElement('scrollElement', 100)">
                        Оценить другое устройство
                      </div>
                      <div class="eval-select__link"
                           @click="scrollToElement('form', 100)">
                        Остались вопросы?
                      </div>
                    </div>
                  </div>

                </div>

                <div id="evalCost" class="eval-cost">
                  <div class="eval-cost__content">
                    <div class="eval-cost__title">
                      <h3
                          v-text="arData.arLibrary.FORM_TEXT_BLOCKS.EVAL_COST_TITLE.DETAIL_TEXT"
                      >
                      </h3>
                    </div>
                    <div class="eval-cost__evaluation-text"
                         v-if="arSelection.bottomCost >= arSelection.mingrade && arSelection.topCost != arSelection.bottomCost">
                      от
                      <strong>{{arSelection.bottomCost}}</strong>₽
                      до
                      <strong>{{arSelection.topCost}}</strong>₽
                    </div>

                    <div class="eval-cost__evaluation-text"
                         v-else-if="arSelection.bottomCost == arSelection.topCost">
                      <strong>{{arSelection.topCost}}</strong>₽
                    </div>

                    <div class="eval-cost__evaluation-text"
                         v-else-if="arSelection.topCost >= arSelection.mingrade">
                      <strong>{{arSelection.topCost}}</strong>₽
                    </div>

                    <div class="eval-cost__evaluation-text"
                         v-else>
                      <strong>{{parseInt(arSelection.mingrade)}}</strong>₽
                    </div>

                    <div class="eval-cost__subtitle"
                         v-text="arData.arLibrary.FORM_TEXT_BLOCKS.EVAL_COST_SUBTITLE.DETAIL_TEXT"
                    >
                    </div>
                    <div class="eval-cost__description"
                         v-html="evalSubtitle">
                    </div>
                  </div>
                </div>

                <div class="eval-also">
                  <div class="eval-also__content">
                    <div class="eval-also__title"
                         v-text="arData.arLibrary.FORM_TEXT_BLOCKS.EVAL_ALSO_TITLE.DETAIL_TEXT"
                    >
                    </div>
                    <div class="eval-also__list"
                         v-html="arData.arLibrary.FORM_TEXT_BLOCKS.EVAL_ALSO_LIST.DETAIL_TEXT"
                    >
                    </div>
                    <div class="eval-also__description">
                      <div class="eval-also__arrow">
                        <img src="img/eval-arrow.png">
                      </div>
                      <div class="eval-also-description__text"
                           v-text="arData.arLibrary.FORM_TEXT_BLOCKS.EVAL_ALSO_DESCRIPTION.DETAIL_TEXT"
                      >
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="eval-select eval-select--2">
                <a href="https://nice-case.ru/catalog/trade_in/" class="eval-select__button button-select-more no-decoration">Купить другое устройство</a>
                <div class="eval-select__text">Выберите другое устройство в каталоге нашего интернет-магазина со скидкой</div>

                <div class="eval-select__links">
                  <div class="eval-select__link"
                       @click="scrollToElement('scrollElement', 100)">
                    Оценить другое устройство
                  </div>
                  <div class="eval-select__link"
                       @click="scrollToElement('form', 100)">
                    Остались вопросы?
                  </div>
                </div>
              </div>

              <div id="form" class="eval-form">
                <div class="form__content">
                  <div class="form__title"
                       v-html="arData.arLibrary.FORM_TEXT_BLOCKS.FORM_TITLE.DETAIL_TEXT"
                  >
                  </div>
                  <div class="form__input-list">
                    <div class="form__input-column">
                      <div class="form__input-item"
                           :class="{'--error' : formError.name}">
                        <div class="form-error"
                             v-if="formError.name">
                          {{formError.name}}
                        </div>
                        <input type="text" v-model="formData.name" name="name" placeholder="Имя">
                      </div>
                      <div class="form__input-item"
                           :class="{'--error' : formError.phone}">
                        <div class="form-error"
                             v-if="formError.phone">
                          {{formError.phone}}
                        </div>
                        <input type="tel" v-model="formData.phone" v-mask="'+7 (###) ###-##-##'" name="phone" placeholder="Телефон">
                      </div>
                      <div class="form__input-item"
                           :class="{'--error' : formError.mail}">
                        <div class="form-error"
                             v-if="formError.mail">
                          {{formError.mail}}
                        </div>
                        <input type="email" v-model="formData.mail" name="email" placeholder="Email">
                      </div>
                    </div>
                    <div class="form__textarea-column">
                      <div class="form__textarea"
                           :class="{'--error' : formError.text}">>
                        <div class="form-error"
                             v-if="formError.text">
                          {{formError.text}}
                        </div>
                        <textarea v-model="formData.text" placeholder="Ваше сообщение"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="form__button">
                    <label class="form__agreement">
                      <input type="checkbox" checked v-model="formData.checkbox">
                      <span>Я <a href="/include/consent_detail.php" target="_blank">согласен(на)</a>  на <a href="/include/licenses_detail.php" target="_blank">обработку персональных данных</a></span>
                      <div style="color: #F13769; padding-left: 0; padding-top: 5px"
                            v-if="formError.checkbox">{{formError.checkbox}}</div>
                    </label>
                    <a class="btn btn-default animate-load has-ripple"
                       @click="sendForm()">
                      Отправить
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>



  </section>

  <div class="major-overlay"
       v-if="overlayState"
       @click="overlayClose()">
    <div class="notifier">
      <div class="notifier__text"
           v-html="arData.arLibrary.FORM_TEXT_BLOCKS.NOTIFIER__TEXT.DETAIL_TEXT"
      >
      </div>
    </div>
  </div>
</template>

<script>

import '@/scss/index.scss'

import axios from 'axios'
import {mask} from 'vue-the-mask'

export default {
  name: 'app',
  data() {
    return {
      costWithoutToolsMin: 0,
      costWithoutToolsMax: 0,
      evalSubtitle: false,
      deviceHasParameters: false,
      deviceHasParametersFilled: false,
      hideModelsFlag: false,
      isSecondRun: false,
      isSliderHovered: false,
      overlayState: false,
      state: 'device',
      arData: [],
      description : '',
      evalTitle: '',
      evalDescription: '',
      arrButtons: [],
      allShown: false,
      modelsQuantity: 12,
      modelsQuantityLimit: 12,
      modelsLength: 0,
      arSelection: [],
      arStages: [],
      modelListState: false,
      colourListState: false,
      itemListState: false,
      formError: {
        name: false,
        phone: false,
        mail: false,
        text: false,
        checkbox: false
      },
      formData: {
        name: '',
        phone: '',
        mail: '',
        text: '',
        deviceName: '',
        deviceDescription: '',
        deviceCost: '',
        checkbox: ''
      }
    }
  },
  directives: {
    mask
  },
  methods : {
    changeModelList() {
      this.modelsLength = this.arData.arModels.length;

      if (this.allShown) {
        this.modelsQuantity = 12
      }
      else  {
        this.modelsQuantity = this.modelsLength
      }
      this.allShown = !this.allShown;
    },
    selectDevice(device) {
      this.description = '';
      this.evalTitle = '';
      this.evalDescription = '';
      this.state = 'model';
      let that = this;
      this.arSelection.device = device;
      switch (this.arSelection.device.CODE) {
        case 'trade_in_iphone':
          this.arSelection.device.surname = 'iPhone ';
          break;
        case 'trade_in_watch':
          this.arSelection.device.surname = 'Apple Watch ';
          break;
        default:
          this.arSelection.device.surname = '';
      }
      this.arSelection.maxgrade = false;

      this.arData.arItems = false;
      this.arSelection.model = false;

      this.arSelection.item = false;
      this.arData.arProperties = false;

      this.arSelection.props = false;

      this.arSelection.state = 'model';
      axios.post('/api/getSections.php', {
        id: device.ID,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            that.arData.arModels = response.data;
            that.scrollToElement('models', 250);
          });
    },
    selectModel(model) {
      this.modelListState = false;
      let that = this;
      this.arSelection.model = model;
      this.arSelection.colour = false;
      this.arSelection.item = false;
      this.arData.arProperties = false;
      this.arSelection.props = false;
      this.description = '<div class="info__item">' + this.arSelection.device.surname + this.arSelection.model.NAME + '</div> '

      this.arSelection.state = 'item';
      axios.post('/api/getElements.php', {
        id: model.IBLOCK_ID,
        sectionId: model.ID,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            that.arData.arItems = response.data;
            if (that.arData.arItems.length == 1) {
              that.hideModelsFlag = true;
              that.selectItem(that.arData.arItems[0]);
            } else {
              that.hideModelsFlag = false;

              if (that.arSelection.model.UF_COLOURS) {
                that.scrollToElement('colours',200);
              } else {
                that.scrollToElement('items', 200);
              }
            }
          });
    },
    selectColour(colour) {
      if (this.arSelection.colour == colour) {
        this.arSelection.colour = false;
      } else {
        this.arSelection.colour = colour;
      }
      this.arSelection.state = 'item';
      this.description = '<div class="info__item">' + this.arSelection.device.surname + this.arSelection.model.NAME + '</div> '
      this.description += this.arSelection.colour ? '<div class="info__item">' + this.arSelection.colour + '</div>' : '';
      this.evalTitle = '';
      this.evalDescription = '';
      this.colourListState = false;
      this.arSelection.item = false;

      this.arSelection.maxgrade = false;
      this.arSelection.item = false;
      this.arData.arProperties = false;
      this.arSelection.props = false;
      this.scrollToElement('items', 200);
    },
    selectItem(item) {
      this.itemListState = false;
      let that = this;
      this.arSelection.item = item;
      if (this.arSelection.device.CODE == 'trade_in_ipad' || this.arSelection.device.CODE == 'trade_in_airpods' || this.arSelection.device.CODE == 'trade_in_mouse') {
        this.description = '';
      } else {
        this.description = '<div class="info__item">' + this.arSelection.device.surname + this.arSelection.model.NAME + '</div> ';
      }

      this.description += this.arSelection.colour ? '<div class="info__item">' + this.arSelection.colour + '</div>' : '';
      this.description += '<div class="info__item">'+ this.arSelection.item.DISPLAY_NAME + '</div>';
      this.evalTitle = this.arSelection.device.surname + this.arSelection.item.NAME
      this.evalDescription = '';
      this.arSelection.props = false;
      this.arSelection.state = 'props';
      axios.post('/api/getProperties.php', {
        id: item.ID,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            that.arData.arGroups = [];
            that.arData.arProperties = response.data;
            let groupCounter = 0;
            let stageCounter = 2;
            that.deviceHasParameters = false;
            for (let stage in that.arData.arProperties.PROPERTIES) {
              if(that.arData.arProperties.PROPERTIES[stage].CODE != 'PARAMETERS') {

                let temp = {};
                temp.name = stage;
                temp.number = '0' + stageCounter;
                temp.counter = stageCounter;
                temp.styleObject = {
                  width: stageCounter / 3 * 100 + '%'
                };
                temp.id = stage.toLowerCase();
                temp.active = false;
                that.arStages[stage] = temp;
                stageCounter++;
              } else {
                that.deviceHasParameters = true;
              }

              if (!that.deviceHasParameters) {
                that.arStages.CONDITION.active = true
              }
              for (let groupItem in that.arData.arProperties.PROPERTIES[stage].GROUP) {
                that.arData.arGroups[that.arData.arProperties.PROPERTIES[stage].GROUP[groupItem].CODE] = {
                  key : groupCounter,
                  id : that.arData.arProperties.PROPERTIES[stage].GROUP[groupItem].CODE.toLowerCase(),
                  code : that.arData.arProperties.PROPERTIES[stage].GROUP[groupItem].CODE,
                  stage : stage,
                  active : false,
                  hasError : false,
                }
                groupCounter++;
                that.arData.arProperties.PROPERTIES[stage].GROUP[groupItem].id = that.arData.arProperties.PROPERTIES[stage].GROUP[groupItem].CODE.toLowerCase()
              }

            }
            stageCounter--;
            for (let stage in that.arStages) {
              that.arStages[stage].number = '0' + that.arStages[stage].counter + '/0' + stageCounter;
              that.arStages[stage].styleObject = {
                width: that.arStages[stage].counter / stageCounter * 100 + '%'
              };
            }

            that.scrollToFirst();
            that.arSelection.maxgrade = parseInt(response.data.MAXGRADE.VALUE);
            that.arSelection.mingrade = parseInt(response.data.MINGRADE.VALUE);
            that.arData.groupsQuantity = groupCounter;

          })
    },
    scrollToFirst() {
      for (let group in this.arData.arGroups) {
        if (this.arData.arGroups[group].key == 0) {
          setTimeout(() => this.smoothScroll(document.getElementById(this.arData.arGroups[group].id.toString()),200), 1000);
        }
      }
    },
    scrollToElement (id, offset) {
      setTimeout(() => this.smoothScroll(document.getElementById(id.toString()), offset), 50);
    },
    scrollToInactive () {

      for (let keygroup in this.arData.arGroups) {
        if (this.arData.arGroups[keygroup].active == false && this.arData.arGroups[keygroup].code != 'TOOL' ) {
          this.arData.arGroups[keygroup].hasError = true;
        }
      }
      for (let keygroup in this.arData.arGroups) {
        if (this.arData.arGroups[keygroup].active == false) {
          this.scrollToElement(this.arData.arGroups[keygroup].id, 200)
          break;
        }
      }
    },
    selectProp(stage, group, item) {

      if (stage.CODE != 'TOOLS') {
        // Логика ИЛИ
        for (let groupItem in group.PROPERTY) {
          if (item.CODE != group.PROPERTY[groupItem].CODE) {
            group.PROPERTY[groupItem].active = false;
          }
        }
      }

      // Отмена выбора
      if (!item.active) {
        item.active = true;
      } else {
        item.active = false;
      }

      let tempAdd = 0;
      let tempMultiMin = 1.00;
      let tempMultiMax = 1.00;
      let stageFlag = false;
      let evalFlag = true;
      let descriptionText = '';
      let descriptionGroup = '';
      let descriptionValue = '';
      let stageName =  '';
      let stageActive = true;
      let descriptionTextForMail = '';
      let descriptionGroupForMail = '';
      let descriptionValueForMail = '';

      for (let tempStage in this.arData.arProperties.PROPERTIES) {
        stageFlag = true;


        for (let tempGroup in this.arData.arProperties.PROPERTIES[tempStage].GROUP) {

          let itemFlag = tempStage == 'TOOLS';
          descriptionValue = '';
          descriptionGroupForMail = this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].NAME;
          descriptionValueForMail = '';

          this.arData.arGroups[tempGroup].active = false;

          for (let tempPropIterator in this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].PROPERTY) {

            let tempProp = this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].PROPERTY[tempPropIterator];

            if (!tempProp.active) continue

            this.arData.arGroups[tempGroup].active = true;

            itemFlag = true;

            if (this.arData.arProperties.PROPERTIES[tempStage].CODE == 'TOOLS' && descriptionValue || this.arData.arProperties.PROPERTIES[tempStage].CODE == 'TOOLS' && descriptionValueForMail ) {
              descriptionValue = descriptionValue + '<div class="info__item">' + tempProp.NAME + '</div>';
              descriptionValueForMail += ', ' + tempProp.NAME
            } else {
              switch (tempProp.CODE) {
                case 'CONDITION_SCREEN_YES':
                  descriptionValue = '<div class="info__item">' + 'Замена экрана была' + '</div>';
                  descriptionValueForMail = 'Замена экрана была';
                  break;
                case 'CONDITION_SCREEN_NO':
                  descriptionValue = '<div class="info__item">' + 'Не было замены экрана' + '</div>';
                  descriptionValueForMail = 'Не было замены экрана';
                  break;
                default:
                  descriptionValue = '<div class="info__item">' + tempProp.NAME + '</div>';
                  descriptionValueForMail = tempProp.NAME;
              }
            }

            if (tempProp.VALUE.indexOf('*') == -1) {
              if (this.arData.arProperties.PROPERTIES[tempStage].CODE == 'TOOLS' && this.costWithoutToolsMax < 1500) {
                tempAdd += 100;
              } else {
                tempAdd += parseInt(tempProp.VALUE, 10);
              }

            } else {
              if (parseInt(tempProp.VALUE.substr(0, tempProp.VALUE.indexOf('*'))) >= parseInt(tempProp.VALUE.substr(tempProp.VALUE.indexOf('*') + 1))) {
                tempMultiMin *= 1 - (parseInt(tempProp.VALUE.substr(0, tempProp.VALUE.indexOf('*'))) / 100);
                tempMultiMax *= 1 - (parseInt(tempProp.VALUE.substr(tempProp.VALUE.indexOf('*') + 1)) / 100);
              } else {
                tempMultiMax *= 1 - (parseInt(tempProp.VALUE.substr(0, tempProp.VALUE.indexOf('*'))) / 100);
                tempMultiMin *= 1 - (parseInt(tempProp.VALUE.substr(tempProp.VALUE.indexOf('*') + 1)) / 100);
              }
            }

          }
          stageFlag = stageFlag && itemFlag;

          if (descriptionValue) {
            descriptionGroup = descriptionGroup ? descriptionGroup + descriptionValue : descriptionValue;
            descriptionValue = '';
          }
          if (descriptionValueForMail) {
            descriptionTextForMail += descriptionGroupForMail + ' ' + descriptionValueForMail + '<br />';
          }

          stageActive = stageActive && this.arData.arGroups[tempGroup].active;

        }
        if (this.arData.arProperties.PROPERTIES[tempStage].CODE != 'PARAMETERS') {
          if (stageActive) {
            this.arStages[tempStage].active = true;
          } else {
            this.arStages[tempStage].active = false;
          }
        }

        descriptionGroup = descriptionGroup ? stageName  + descriptionGroup : '';
        descriptionText = descriptionText ? descriptionText + descriptionGroup : descriptionGroup;
        descriptionGroup = '';
        stageName = '';
        evalFlag = stageFlag && evalFlag;
      }
      if (this.arSelection.device.CODE == 'trade_in_ipad' || this.arSelection.device.CODE == 'trade_in_airpods' || this.arSelection.device.CODE == 'trade_in_mouse') {
        this.description = '';
      } else {
        this.description = '<div class="info__item">' + this.arSelection.device.surname + this.arSelection.model.NAME + '</div> ';
      }
      this.description += this.arSelection.colour ? '<div class="info__item">' + this.arSelection.colour + '</div>' : '';
      this.description += '<div class="info__item">'+ this.arSelection.item.DISPLAY_NAME + '</div>';
      this.description +=  descriptionText;
      this.evalTitle = this.arSelection.item.NAME;
      this.evalDescription = this.arSelection.item.NAME.indexOf(this.arSelection.item.DISPLAY_NAME) == -1 ?  '<div class="info__item">' + this.arSelection.item.DISPLAY_NAME + '</div>' : '';
      this.evalDescription += this.arSelection.colour ? '<div class="info__item">' + this.arSelection.colour + '</div>' : '';
      this.evalDescription += descriptionText;
      this.costWithoutToolsMin = this.arSelection.maxgrade * tempMultiMin;
      this.costWithoutToolsMax = this.arSelection.maxgrade * tempMultiMax;
      this.arSelection.bottomCost = parseInt(this.arSelection.maxgrade * tempMultiMin + tempAdd);
      this.arSelection.topCost = parseInt(this.arSelection.maxgrade * tempMultiMax + tempAdd);
      this.formData.deviceName = this.evalTitle;
      this.formData.deviceDescription = this.arSelection.colour ? 'Цвет: ' + this.arSelection.colour + '<br />' + descriptionTextForMail : descriptionTextForMail;
      this.formData.deviceCost = this.arSelection.bottomCost ==  this.arSelection.topCost ? this.arSelection.bottomCost : this.arSelection.bottomCost  + ' - ' + this.arSelection.topCost;

      if (this.arSelection.device.CODE == 'trade_in_ipad' || this.arSelection.device.CODE == 'trade_in_airpods' || this.arSelection.device.CODE == 'trade_in_mouse') {
        this.formData.deviceName = this.arSelection.item.DISPLAY_NAME;
      } else {
        this.formData.deviceName = this.arSelection.device.surname + this.arSelection.model.NAME;
        this.formData.deviceDescription = this.arSelection.item.DISPLAY_TITLE + ' ' +  this.arSelection.item.DISPLAY_NAME + '<br />' + this.formData.deviceDescription;
      }

      if (evalFlag) {
        this.setState('pre-eval');
      } else {
        this.setState('props');
      }
      let nextKey = this.arData.arGroups[group.CODE].key + 1;
      if (nextKey < this.arData.groupsQuantity) {
        for (let keygroup in this.arData.arGroups) {
          if (this.arData.arGroups[keygroup].key == nextKey) {
            this.scrollToElement(this.arData.arGroups[keygroup].id, 200);
            break;
          }
        }
      }
      this.arData.arGroups[group.CODE].hasError = false;

      let parametersFlag = true;
      if (this.deviceHasParameters) {
        for (let keygroup in this.arData.arGroups) {
          if (this.arData.arGroups[keygroup].stage == 'PARAMETERS') {
            parametersFlag = parametersFlag && this.arData.arGroups[keygroup].active;
          }
        }
      }

      let conditionFlag = true;
      for (let keygroup in this.arData.arGroups) {
        if (this.arData.arGroups[keygroup].stage == 'CONDITION') {
          conditionFlag = conditionFlag && this.arData.arGroups[keygroup].active;
        }
      }

      if (parametersFlag) {
        this.arStages.CONDITION.active = true
        if (conditionFlag && this.arStages.TOOLS) {
          this.arStages.TOOLS.active = true
        } else {
          for (let tempStage in this.arData.arProperties.PROPERTIES) {
            if (tempStage != 'TOOLS') continue
            for (let tempGroup in this.arData.arProperties.PROPERTIES[tempStage].GROUP) {
              for (let tempPropIterator in this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].PROPERTY) {
                this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].PROPERTY[tempPropIterator].active = false;
              }
            }
          }
        }

      } else {
        for (let tempStage in this.arData.arProperties.PROPERTIES) {
          if (tempStage == 'PARAMETERS') continue
          for (let tempGroup in this.arData.arProperties.PROPERTIES[tempStage].GROUP) {
            for (let tempPropIterator in this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].PROPERTY) {
              this.arData.arProperties.PROPERTIES[tempStage].GROUP[tempGroup].PROPERTY[tempPropIterator].active = false;
            }
          }
        }
      }

      this.deviceHasParametersFilled = parametersFlag;

    },

    setState(state) {
      this.arSelection.state = state;
      if (state == 'eval') {
        this.scrollToElement('evalStage',50);
        this.evalSubtitle = false;
        for (let property in this.arData.arLibrary.EVAL_SUBTITLES[this.arSelection.device.CODE]) {
          if (this.evalSubtitle) break;
          for (let sort = 20; sort < 201; sort += 20) {

            let obProperty = this.arData.arLibrary.EVAL_SUBTITLES[this.arSelection.device.CODE][property];
            if (sort == obProperty.SORT) {
              if (this.arData.arProperties.PROPERTIES[obProperty.STAGE].GROUP[obProperty.GROUP].PROPERTY[obProperty.PROPERTY].active) {
                this.evalSubtitle = obProperty.TEXT;
                break;
              }
            } else continue
          }
        }
        ym(69212236,'reachGoal','calc_finish');
        _tmr.push({ type: 'reachGoal', id: 3312948, goal: 'calc-finish-vk'});
      }
    },
    sendForm() {
      let that = this;

      if (!this.formData.name) {
        this.formError.name = 'Поле Имя не заполнено';
      } else {
        this.formError.name = false;
      }

      if (!this.formData.phone) {
        this.formError.phone = 'Поле Телефон не заполнено';
      } else {
        this.formError.phone = false;
      }

      if (!this.formData.mail) {
        this.formError.mail = 'Поле E-mail не заполнено';
      } else {
        this.formError.mail = false;
      }

      if (!this.formData.text) {
        this.formError.text = 'Поле Комментарий не заполнено';
      } else {
        this.formError.text = false;
      }
      if (!this.formData.checkbox) {
        this.formError.checkbox = 'Необходимо дать согласие на обработку персональных данных'
      } else {
        this.formError.checkbox = false;
      }
      console.log(this.formData.checkbox);

      if (this.formError.name || this.formError.phone || this.formError.mail || this.formError.text || this.formError.checkbox) {

      } else  {

        let key = parseInt(Math.random() * 100);
        axios.post('/api/createFormElement.php', {
          name: that.formData.name,
          phoneNumber: that.formData.phone,
          mail: that.formData.mail,
          device: that.formData.deviceName,
          description: that.formData.deviceDescription,
          cost: that.formData.deviceCost,
          comment: that.formData.text,
          privateKey: parseInt(Math.random() * 100) * 2 * 3 * 7 + key,
          privatePhrase: key,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(function (response) {

              ym(69212236,'reachGoal','form_trade_in');
              _tmr.push({ type: 'reachGoal', id: 3312948, goal: 'calc-form-vk'});
            })

        this.overlayState = true;
      }
    },
    overlayClose() {
      this.overlayState = !this.overlayState;
      window.location.reload()
    },
    getTop (element, start) {
      if (element) {
        return element.getBoundingClientRect().top + start
      } else {
        return start
      }
    },
    smoothScroll (scrollTo, offset) {

      let requestAnimationFrame;

      const easeInOutCubic = t => t < 0.5 ? 16 * t * t * t * t * t  : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;

      if (!requestAnimationFrame) {
        requestAnimationFrame = window.requestAnimationFrame || (fn => window.setTimeout(fn, 16))
      }

      const startPoint = window.scrollTop || window.pageYOffset;
      const end = this.getTop(scrollTo, startPoint) - offset;

      const clock = Date.now();
      const step = () => {
        // The time elapsed from the beginning of the scroll
        const elapsed = Date.now() - clock;
        // Calculate the scroll position we should be in
        const scrolling = elapsed < 1000;
        const position = scrolling ? startPoint + (end - startPoint) * easeInOutCubic(elapsed / 1000) : end;

        if (scrolling) {
          requestAnimationFrame(step);
        }

        window.scrollTo(0, position);
      }
      step()
    },
    pressBackButton() {
      if (this.arSelection.state == 'device') {
        history.back();
      } else if (this.arSelection.state == 'eval') {
        this.setState('pre-eval');
        this.scrollToElement('models', 200);
      } else {
        this.setState('device');
        this.scrollToElement('app', 50);
      }
    }
  },

  beforeMount() {
    let that = this;
    this.arSelection.state = 'device';

  },
  mounted() {
    let el = document.getElementById("backButton");
    let scrollEl = document.getElementById("scrollElement");
    el.addEventListener("click", this.pressBackButton, false);
    scrollEl.onscroll = function (ev) {
      ev.stopPropagation();
    }
    let that = this;
    axios.get('/api/getDevices.php')
        .then(function (response) {
          that.arData.arDevices = response.data;
          that.scrollToElement('app', 50);
        })
    axios.get('/api/getImages.php')
        .then(function (response) {
          that.arData.arLibrary = response.data;
        })
    this.arData.arProperties = false;
    this.arSelection.bottomCost = false;
    this.arSelection.topCost = false;
  },
  updated() {
  },
  computed() {
  }

}

</script>
